import { useEffect } from 'react';
import { usePortal, useTranslation } from '../../../../../hooks/useNavConfig';
import { useAppDispatch, useAppSelector } from '../../../../../hooks';
import { fetchCreditsData } from '../../../../../reducers/Credits';
export const useHubspotCreditsData = ({
  displayCreditsIndicator
}) => {
  const {
    t
  } = useTranslation();
  const {
    portalId
  } = usePortal();
  const dispatch = useAppDispatch();
  const {
    totalCredits,
    creditsUsed,
    isLoading,
    hasError
  } = useAppSelector(state => state.credits);
  const creditsRemaining = totalCredits - creditsUsed;
  const creditDisplayText = creditsRemaining <= 0 ? t('nav.account.credits.noCredits') : t('nav.account.credits.count', {
    count: String(creditsRemaining),
    total: String(totalCredits)
  });
  useEffect(() => {
    if (!portalId || !displayCreditsIndicator) {
      return;
    }
    void dispatch(fetchCreditsData());
  }, [dispatch, displayCreditsIndicator, portalId]);
  return {
    creditDisplayText,
    isLoading,
    hasError
  };
};